import { Alert, ButtonProps, Stack, StackProps } from '@chakra-ui/react';
import { useVerifyAuthProvider } from '@waitroom/auth';
import { navigateTo } from '@waitroom/common';
import { AuthType } from '@waitroom/models';
import { CallbackOrAction } from '@waitroom/react-utils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { APPLE_CLIENT_ID, GOOGLE_CLIENT_ID } from '../../config';
import AppleAuth from './Apple/Apple';
import GoogleAuth from './Google/Google';
import { SocialButtonProps } from './types';

export interface SocialAuthProps extends StackProps {
  onCompleted?: CallbackOrAction;
  redirectUrl?: string;
  clientId?: string;
  isSignup: boolean;
  buttonProps?: ButtonProps;
  state?: string;
  codeChallenge?: string;
}

const SocialAuth = ({
  onCompleted,
  redirectUrl,
  clientId,
  isSignup,
  buttonProps,
  state,
  codeChallenge,
  ...rest
}: SocialAuthProps): React.ReactElement | null => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<AuthType>();
  const [error, setError] = useState(false);
  const mutation = useVerifyAuthProvider({
    onRedirect: navigateTo,
  });

  const props: SocialButtonProps = {
    onCompleted,
    setError,
    loading,
    setLoading,
    mutation,
    redirectUrl,
    clientId,
    isSignup,
    state,
    codeChallenge,
    ...buttonProps,
  };
  return (
    <>
      <Stack direction={{ base: 'column', xl: 'row' }} spacing={4} align="center" {...rest}>
        {GOOGLE_CLIENT_ID && <GoogleAuth {...props} />}
        {APPLE_CLIENT_ID && <AppleAuth {...props} />}
      </Stack>
      {error ? (
        <Alert status="error" mt={4}>
          {t('auth.ssoError')}
        </Alert>
      ) : null}
    </>
  );
};

export default SocialAuth;
